// src/pages/OfflinePage.js
import React from 'react';
import { useTranslation } from 'react-i18next';

function OfflinePage() {
  const { t } = useTranslation();
  
  return (
    <main className="container py-4" role="main">
      <div className="text-center">
        <h1 className="mb-4">{t('offline.title')}</h1>
        <div 
          role="alert" 
          aria-live="polite" 
          className="alert alert-warning d-inline-block"
        >
          <p className="mb-3">
            {t('offline.message')}
          </p>
          <button 
            className="btn btn-primary"
            onClick={() => window.location.reload()}
            aria-label={t('offline.tryAgainLabel')}
          >
            {t('offline.tryAgain')}
          </button>
        </div>
        <div className="mt-4">
          <h2 className="h4 mb-3">{t('offline.availableFeatures.title')}:</h2>
          <ul 
            className="list-unstyled" 
            role="list" 
            aria-label={t('offline.availableFeatures.label')}
          >
            {t('offline.availableFeatures.list', { returnObjects: true }).map((feature, index) => (
              <li key={index}>✓ {feature}</li>
            ))}
          </ul>
        </div>
      </div>
    </main>
  );
}

export default OfflinePage;
